import PerformanceTrack from "./PerformanceTrack";

const valueMap = {};

export default class PerformanceMetrics {
    constructor() {
    }

    /**
     * @param {string} subject 
     */
    static startTime(subject) {
        /**
         * @type {PerformanceTrack}
         */
        let value = valueMap[subject];
        if (!value) {
            value = new PerformanceTrack(subject);
            valueMap[subject] = value;
        }

        value.startTimer();
    }

    /**
     * @param {string} subject 
     */
    static endTime(subject) {
        /**
         * @type {PerformanceTrack}
         */
        const value = valueMap[subject];
        if (!value) {
            console.log('PerformanceMetrics: failed to find: ' + subject);
            return;
        }

        value.endTimer();
    }

    /**
     * @returns {string[]}
     */
    static getKeys() {
        return Object.keys(valueMap);
    }

    /**
     * @param {string} key 
     * @returns {PerformanceTrack}
     */
    static getPerformanceTrack(key) {
        return valueMap[key];
    }


    static reset() {

        for (const [key] of Object.entries(valueMap)) {
            /**
             * @type {PerformanceTrack}
             */
            const performanceTrack = valueMap[key];
            if (performanceTrack) {
                performanceTrack.reset();
            }
        }
    }   
}